import React, { Fragment } from "react";

const DiscussionInvites = ({ invite, discussion, index, setDiscussion }) => {
  return (
    <Fragment>
      <div className="user-section">
        <div className="friends-user-container">
          <div className="friend-user-avi-container">
            <div className="avi-color-border green">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${invite.avatar}`}
                className="friend-user-avi"
              />
            </div>
          </div>
          <div className="friend-user-info">
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="green name-font">{invite.channelid}</span>
                </li>
                <li className="user-online-item">
                  {invite.firstname} {invite.lastname}
                </li>
                <li className="user-online-item">{invite.jobtitle}</li>
                <li className="user-online-item">
                  {invite.location && invite.location.city},{" "}
                  {invite.location && invite.location.state}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="friends-buttons-container">
          <div className="friend-button-container">
            <button
              className="friend-button background-green"
              index={index}
              onClick={(e) => {
                discussion.invites.splice(
                  e.currentTarget.attributes.index.value,
                  1
                );
                setDiscussion({
                  ...discussion,
                  invites: [...discussion.invites],
                });
              }}
            >
              <i className="far fa-times-circle mx-5"></i>
              Remove
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default DiscussionInvites;
